/**
 * タグタイプの列挙型
 * タグの種類を定義する
 */
enum TagTypeEnum {
  /** 手動タグ */
  manual = "manual",
  // template = "template", // 非推奨: manual tagに移行済み
  /** パートナータグ（RIPICLE等） */
  partner = "partner",
}

/**
 * タグタイプの表示順序を定義する列挙型
 * 数値が小さいほど優先度が高い
 */
enum TagTypeOrderEnum {
  /** パートナータグの優先度（最優先） */
  partner = 1,
  /** 手動タグの優先度 */
  manual = 2,
  // template = 3, // 非推奨: manual tagに移行済み
}

/**
 * タグタイプの日本語表示名を定義する列挙型
 */
enum TagTypeNameEnum {
  /** 手動タグの表示名 */
  manual = "手動タグ",
  // template = "テンプレートタグ", // 非推奨: manual tagに移行済み
}

export { TagTypeEnum, TagTypeNameEnum, TagTypeOrderEnum };
